import { jsx as _jsx } from "react/jsx-runtime";
import CategoryButton from '../CategoryButton';
import styles from './Categories.module.scss';
const Categories = ({ onClickCategory, openedCategory, showAllCategories = false, categories, redirectTo }) => {
    let categoriesToRender = categories !== null && categories !== void 0 ? categories : [];
    if (!showAllCategories) {
        categoriesToRender = categoriesToRender.filter((category) => category.title === 'Produkter');
    }
    return (_jsx("div", Object.assign({ className: styles.wrapper }, { children: categoriesToRender.map((category) => (_jsx(CategoryButton, Object.assign({ hasChildItems: category.child_items != null && category.child_items.length > 0, onClick: () => onClickCategory(category.title), isOpen: category.title === openedCategory, "data-cy": `category-button-${category.ID}`, url: category.url, redirectTo: redirectTo }, { children: category.title }), category.title))) })));
};
export default Categories;
